export class CommunicationService {
  static _instance = null;

  static getInstance() {
    return CommunicationService._instance || (CommunicationService._instance = new CommunicationService());
  }

  setWidgetTarget(widgetTarget) {
    this.widgetTarget = widgetTarget;
    this._tryAttemps = 0;
  }

  async requestToParent(command, data) {
    return new Promise((resolve, reject) => {
      const responseMessageId = `ResponseToCommand_${command}_${new Date().getTime()}`;
      const onResponseReceive = (event) => {
        if (event.data.action === responseMessageId) {
          delete event.data.action;
          resolve(event.data);
          window.removeEventListener('message', onResponseReceive);
        }
      };

      window.addEventListener('message', onResponseReceive);

      window.parent.postMessage({
        action: command,
        responseCommand: responseMessageId,
        data
      }, '*');
    });
  }

  async requestToWidget(command, data) {

    if (!this.widgetTarget) {
      if (this._tryAttemps >= 3) {
        this._tryAttemps = 0;
        return;
      } else {
        this._tryAttemps++;
        setTimeout(() => this.requestToWidget(command, data), 500);
      }
    }

    return new Promise((resolve, reject) => {
      const responseMessageId = `ResponseToCommand_${command}_${new Date().getTime()}`;
      const onResponseReceive = (event) => {
        if (event.data.action === responseMessageId) {
          delete event.data.action;
          resolve(event.data);
          window.removeEventListener('message', onResponseReceive);
        }
      };

      window.addEventListener('message', onResponseReceive);

      this.widgetTarget.contentWindow.postMessage({
        action: command,
        responseCommand: responseMessageId,
        data
      }, '*');
    });
  }
}

export const communicationService = CommunicationService.getInstance();



// WEBPACK FOOTER //
// ./src/services/communicationService.js